export const RECEIVE_PAGES = 'RECEIVE_PAGES'

export const RECEIVE_SITE = 'RECEIVE_SITE'

export const UPDATE_APP = 'UPDATE_APP'



// WEBPACK FOOTER //
// ./client/store/mutation-types.js